import agentDeskProperties from '@/services/liveAgent/constants/agentDeskProperties'
import { addAgentInfoInLocalStorage, removeAgentInfoInLocalStorage } from '@/services/liveAgent/utils/utils'
import { chatEvents, constantStrings, feedback } from '../../constants'
import store from '@/store'
import { GlobalVars } from '@/services/globals'
import seperatorMessageFormatter from '@/services/liveAgent/messageFormatter/seperatorMessageFormatter'
import { formatTime, formatTimestampToMDYDate } from '../../utils'

export function handleSecureForm(eventInfo, timestamp, isLastResponse, { subType }) {
  store.dispatch('handleSecureForm', { timestamp, eventInfo, subType, isLastResponse })
}

export function handleCSATSubmitEvent({ feedbackValue, submitSurveyInfo }, timestamp, isLastResponse) {
  if (submitSurveyInfo) {
    if (feedbackValue !== store.state.csat.rating) {
      store.dispatch('updateCSATIcons', feedbackValue === feedback.POSITIVE)
    }
    const additionalFeedback = submitSurveyInfo?.additionalFeedback
    store.dispatch('updateCSATState', { comment: additionalFeedback })
    store.dispatch('updateQuickReplyOptions', [])
  } else {
    let rating = feedbackValue
    if (feedbackValue === "") {
      rating = store.state.csat.rating
    }
    store.dispatch('updateCSATIcons', rating === feedback.POSITIVE)
    if (isLastResponse) {
      store.dispatch('updateCSATQuickReply')
    }
  }
  showPill(chatEvents.SUBMIT, { feedbackValue, submitSurveyInfo, hideComment: true }, timestamp)
}

export function handleAgentJoinEvent({ agentName, agentAvatar }, timestamp) {
  const avatar = agentAvatar || store.state.agentInfo?.avatar || `${GlobalVars.$cdn}/images/agent_default.svg`
  store.dispatch('updateAgentInfo', { avatar, displayName: agentName })
  showPill(agentDeskProperties.EVENT_SUB_TYPES.AGENT_JOIN, { agentName }, timestamp)
}

export function handleAgentJoinConferenceEvent({ agentId, agentName, agentAvatar }, timestamp) {
  addAgentInfoInLocalStorage({ agentId, agentName, agentAvatar })
  showPill(agentDeskProperties.EVENT_SUB_TYPES.AGENT_JOIN_CONFERENCE, { agentName }, timestamp)
}

export function handleAgentLeaveEvent() {
  const agentName = store.state.agentInfo.displayName
  removeAgentInfoInLocalStorage(agentName)
  showPill(agentDeskProperties.EVENT_SUB_TYPES.AGENT_LEAVE, { agentName })
}

export function handleAgentLeftConferenceEvent({ agentId, agentName }, timestamp) {
  removeAgentInfoInLocalStorage(agentId)
  showPill(agentDeskProperties.EVENT_SUB_TYPES.AGENT_LEFT_CONFERENCE, { agentName }, timestamp)
}

export function handleAgentTransferEvent({ agentName, departmentName }, timestamp) {
  const previousAgentName = store.state.agentInfo.displayName
  showPill(agentDeskProperties.EVENT_SUB_TYPES.AGENT_TRANSFER, { previousAgentName, agentName, departmentName }, timestamp)
}

export function handleAgentTransferAndJoinEvent({ agentName, agentAvatar }, timestamp) {
  const previousAgentName = store.state.agentInfo.displayName
  showPill(agentDeskProperties.EVENT_SUB_TYPES.AGENT_TRANSFER_AND_JOIN, { previousAgentName, agentName })
  showPill(agentDeskProperties.EVENT_SUB_TYPES.AGENT_JOIN, { agentName })
  store.dispatch('updateAgentInfo', { avatar: agentAvatar, displayName: agentName }, timestamp)
}

export function handleQueuePositionEvent({ queuePosition }, timestamp) {
  if (!queuePosition || queuePosition <= 0) {
    return
  }
  showPill(agentDeskProperties.EVENT_SUB_TYPES.WAIT, { queuePosition }, timestamp)
}

export function handleGenericInfoEvent({ message }, timestamp) {
  showPill(agentDeskProperties.EVENT_SUB_TYPES.GENERIC_INFO, { messageInfo : message }, timestamp)
}

export function handleChatEndEvent() {
  showPill('CHAT_END')
}

export function handleChatSessionExpire() {
  showPill('SESSION_EXPIRE')
}

export function signInPill() {
  showPill('SIGN_IN')
}

export function signOutPill() {
  showPill('SIGN_OUT')
}

let lastTimestamp = 0
function getUniqueTimestamp() {
  let now = Date.now();
  if (now <= lastTimestamp) {
      now = lastTimestamp + 1 // Ensure uniqueness
  }
  lastTimestamp = now
  return now
}
function showPill(type, data, timestamp = getUniqueTimestamp()) {
  store.dispatch('showMessageSeparator', seperatorMessageFormatter(type, data, timestamp))
}

export function handleChatInputFieldEnable() {
  store.dispatch('updateInputFieldTempDisableStatus', false)
}


export function showTermsAndConditionAcceptMessage(_, timestamp) {
  if(!store.getters.showAcceptance) return 
  const formattedDate = formatTimestampToMDYDate(timestamp)
  const formattedTime = formatTime(timestamp)
  const displayMessage = constantStrings.TERMS_AND_CONDITION_ACCEPTED_MESSAGE.CHAT_WIDGET(`${formattedDate} ${formattedTime}`)
  store.dispatch('showMessageSeparator' , seperatorMessageFormatter("TERMS_AND_CONDITION_ACCEPTED" , displayMessage , timestamp, 'TermsAndConditionSeparator'))
}
